var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.286,
    height: 33.286,
    viewBox: "0 0 33.286 33.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sunny",
    transform: "translate(-19.357 -19.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28423",
    "data-name": "Path 28423",
    d: "M31.007,24.944a1,1,0,0,1-.924-.617L28.6,20.74a1,1,0,1,1,1.848-.766l1.486,3.587a1,1,0,0,1-.924,1.383Z",
    fill: "#ffaa45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28424",
    "data-name": "Path 28424",
    d: "M42.48,52.643a1,1,0,0,1-.924-.617L40.07,48.439a1,1,0,0,1,1.848-.766L43.4,51.26a1,1,0,0,1-.924,1.383Z",
    fill: "#ffaa45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28425",
    "data-name": "Path 28425",
    d: "M20.358,43.479a1,1,0,0,1-.383-1.924l3.587-1.486a1,1,0,0,1,.766,1.848L20.741,43.4a1,1,0,0,1-.383.076Z",
    fill: "#ffaa45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28426",
    "data-name": "Path 28426",
    d: "M48.056,32.007a1,1,0,0,1-.383-1.924L51.26,28.6a1,1,0,0,1,.766,1.848l-3.587,1.486a1.021,1.021,0,0,1-.383.076Z",
    fill: "#ffaa45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28427",
    "data-name": "Path 28427",
    d: "M40.993,24.944a1,1,0,0,1-.923-1.383l1.486-3.587a1,1,0,1,1,1.848.766l-1.486,3.587a1,1,0,0,1-.925.617Z",
    fill: "#ffaa45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28428",
    "data-name": "Path 28428",
    d: "M29.52,52.643A1,1,0,0,1,28.6,51.26l1.486-3.587a1,1,0,1,1,1.848.766l-1.486,3.587A1,1,0,0,1,29.52,52.643Z",
    fill: "#ffaa45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28429",
    "data-name": "Path 28429",
    d: "M23.944,32.007a.993.993,0,0,1-.382-.076l-3.587-1.486a1,1,0,0,1,.766-1.848l3.587,1.486a1,1,0,0,1-.384,1.924Z",
    fill: "#ffaa45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28430",
    "data-name": "Path 28430",
    d: "M51.642,43.479a.993.993,0,0,1-.382-.076l-3.587-1.486a1,1,0,1,1,.766-1.848l3.587,1.486a1,1,0,0,1-.384,1.924Z",
    fill: "#ffaa45"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_505",
    "data-name": "Ellipse 505",
    cx: 10.128,
    cy: 10.128,
    r: 10.128,
    transform: "translate(25.872 25.872)",
    fill: "#ffaa45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28431",
    "data-name": "Path 28431",
    d: "M36,27.869a8.133,8.133,0,1,1-3.107.621A8.11,8.11,0,0,1,36,27.869",
    fill: "#ffda69"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.4753b94467d7fdd0df7cae4aee20b394.svg";
export { ForwardRef as ReactComponent };